<div class="date-picker-container" [formGroup]="config.group" [ngSwitch]="config.group.state">

  <ng-container *ngSwitchCase="'READ'">
      <div [class]="formGroupClass">
          <label *ngIf="config.title" [for]="elementId">{{config.title}}</label>
          <input [edtellTooltip]="tooltip" class="form-control" [id]="elementId" [value]="readValue" [title]="config.title"
              readonly>
      </div>
  </ng-container>

  <ng-container *ngSwitchCase='"WRITE"'>
      <div [class]="formGroupClass">
          <label *ngIf="!hideTitle" [for]="elementId">{{config.title}} <span class="required-asterisk">{{ required ? "*" : "" }}</span></label>
          <div class="input-group">
              <div class="input-group-prepend">
                  <div class="input-group-text">
                      <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
                      <mat-datepicker #myDatepicker></mat-datepicker>
                  </div>
              </div>
              <input [edtellTooltip]="tooltip" [min]="min" [max]="max" [ngClass]="['form-control', validationClass, disabled ? 'disabledHover' : ''].concat(class)" #dateInput
                  [id]="elementId" placeholder="mm/dd/yyyy" [(ngModel)]="dateValue"
                  [ngModelOptions]="{standalone: true}" [matDatepicker]="myDatepicker" (change)="onChange($event)"
                  (dateChange)="onDateChange($event)" (input)="onInput($event)" [title]="config.title"
              [autoFocus]="autoFocus" [disableControl]="disabled" patternInput [regExpPattern]="pattern">
          </div>
          <small class="form-text text-muted" *ngIf="config.hint != null">{{hint}}</small>
          <!-- For Debugging -->
          <!-- touched {{this.control.touched}}, dirty {{this.control.dirty}}, submitted {{this.config.group.submitted}} -->
          <ng-template [ngIf]="showValidators()" *ngFor="let v of config.validators">
              <div class="invalid-feedback d-block" *ngIf="hasError(v.key) == true">{{v.message}}</div>
          </ng-template>
      </div>
  </ng-container>
</div>
